import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/api/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
        } else if (attempts < 10) {
          attempts++;
          setTimeout(poll, 2000);
        } else {
          setStatus("pending");
        }
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#060B14] flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="max-w-md text-center space-y-6">
        {status === "checking" && (
          <>
            <Loader2 className="w-16 h-16 text-[#0099CC] animate-spin mx-auto" />
            <h1 className="text-2xl font-bold text-white">Verification du paiement...</h1>
            <p className="text-[#64748b]">Merci de patienter quelques instants</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-20 h-20 bg-[#10B981]/10 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-10 h-10 text-[#10B981]" />
            </div>
            <h1 className="text-2xl font-bold text-white">Paiement confirme !</h1>
            <p className="text-[#64748b]">Votre abonnement est maintenant actif. Vous pouvez acceder a tous les services de votre plan.</p>
            <Link to="/app">
              <Button className="bg-[#10B981] hover:bg-[#0d9668] text-white px-8">Acceder a mon espace</Button>
            </Link>
          </>
        )}
        {status === "pending" && (
          <>
            <div className="w-20 h-20 bg-[#F59E0B]/10 rounded-full flex items-center justify-center mx-auto">
              <Loader2 className="w-10 h-10 text-[#F59E0B]" />
            </div>
            <h1 className="text-2xl font-bold text-white">Paiement en cours de traitement</h1>
            <p className="text-[#64748b]">Votre paiement est en cours de traitement. Vous recevrez une confirmation par email.</p>
            <Link to="/app"><Button className="bg-[#0099CC] text-white px-8">Retour au dashboard</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto">
              <XCircle className="w-10 h-10 text-red-400" />
            </div>
            <h1 className="text-2xl font-bold text-white">Erreur de verification</h1>
            <p className="text-[#64748b]">Nous n'avons pas pu verifier votre paiement. Contactez le support.</p>
            <Link to="/app"><Button variant="outline" className="border-[#2A3441] text-white">Retour</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
